export const PUBLIC_IMAGES = {
  home: {
    hero: 'https://images.unsplash.com/photo-1709377195538-5522ed0f9e10?crop=entropy&cs=srgb&fm=jpg&q=85',
    solutions: 'https://images.pexels.com/photos/7654403/pexels-photo-7654403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    strategy: 'https://images.pexels.com/photos/4342128/pexels-photo-4342128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    operations: 'https://images.pexels.com/photos/6476192/pexels-photo-6476192.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  pricing: {
    hero: 'https://images.unsplash.com/photo-1698306642516-9841228dcff3?crop=entropy&cs=srgb&fm=jpg&q=85'
  },
  agenda: {
    hero: 'https://images.pexels.com/photos/8068656/pexels-photo-8068656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  partners: {
    hero: 'https://images.pexels.com/photos/7433919/pexels-photo-7433919.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    benefits: 'https://images.pexels.com/photos/36733313/pexels-photo-36733313.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  agencies: {
    hero: 'https://images.pexels.com/photos/6476257/pexels-photo-6476257.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  solutions: {
    internal: 'https://images.pexels.com/photos/7654403/pexels-photo-7654403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    external: 'https://images.pexels.com/photos/7709120/pexels-photo-7709120.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    communication: 'https://images.pexels.com/photos/6476192/pexels-photo-6476192.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    advantage: 'https://images.pexels.com/photos/7433919/pexels-photo-7433919.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  about: {
    hero: 'https://images.pexels.com/photos/4342128/pexels-photo-4342128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    essence: 'https://images.pexels.com/photos/5917721/pexels-photo-5917721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    mission: 'https://images.pexels.com/photos/7654403/pexels-photo-7654403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    vision: 'https://images.pexels.com/photos/6476193/pexels-photo-6476193.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    commitment: 'https://images.pexels.com/photos/8068656/pexels-photo-8068656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  contact: {
    hero: 'https://images.pexels.com/photos/5917721/pexels-photo-5917721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  }
};
